export default __webpack_public_path__ + "static/media/youtube.b4f2b64a.png";